import React from 'react';
import Layout from '../../components/UI/Layout/Layout';
import ClientList from '../../components/Entity/Clients/ClientList/ClientList';

const ClientsPage = () => {
  return <Layout title={'კლიენტები'} fullwidth={0}>
       <ClientList></ClientList>
   </Layout>;
}

export default ClientsPage;
